/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */
/* eslint-disable react/destructuring-assignment */
import React from 'react';
import { Link } from 'react-router-dom';
import * as RT from '../../constants/Routing';

export default class Component extends React.Component {
  // 必要なprops

  closeModal = () => {
    const dialog = document.querySelector('.dialog.active');
    dialog.classList.remove('fadein');
    dialog.classList.add('fadeout');
    setTimeout(() => {
      // eslint-disable-next-line react/destructuring-assignment
      this.props.closeModal();
    }, 1000);
  };

  componentDidMount = () => { };

  render = () => {
    const className = this.props.className
      ? this.props.className + (this.props.isOpen ? 'active fadein' : '')
      : `dialog ${this.props.isOpen ? 'active fadein' : ''}`;
    return (
      <div className={className}>
        <div className="dialog-wrapper transfer-info">
          <div className="dialog-container invoice-modal shadow-sm" style={{ width: '50%' }}>
            <div className="dialog-header ">
              <h2>お振込み先口座情報は下記の通りとなります。</h2>
            </div>
            <div className="dialog-body">
              <h3>お振込先</h3>
              <ul>
                <li><h4>金融機関名 ：<span>三井住友銀行</span></h4></li>
                <li><h4>支店名 ：<span>神田支店 (219)</span></h4></li>
                <li><h4>口座種別 ：<span>普通</span></h4></li>
                <li><h4>口座番号 ：<span>3380198</span></h4></li>
                <li><h4>口座名義 ：<span>カ) シオン</span></h4></li>
              </ul>
              <p>恐れ入りますが振り込み手数料は貴社にてご負担ください。</p>
            </div>
            <div className="dialog-btn">
              <div
                onClick={() => this.props.closeModal()}
                className="btn btn-primary"
              >
                閉じる
                </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}
